<template>
  <div class="modal nb-modal-mask" style="display:block; z-index: 1 !important;" @keydown.esc="handleRetorna">
    <Trap>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 650px; overflow-y: initial !important; margin: 5px auto;">
        <div class="modal-content modal-full-h">
          <div class="modal-header">
            <div class="lbl mb-2" style="font-size: 20px">
                <strong v-if="params.tpmovcaixa == 'S'">Sangria de Caixa</strong>
                <strong v-else>Reforço de Caixa</strong>
            </div>
            <button type="button" class="close" @click="handleRetorna" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pt-3" style="max-height: 100%; overflow-y: auto;">
            <div class="row">
              <div class="col-md-12 col-12">
                <form-field v-model="vmovcaixa.tpmovcaixa" type="select" col="6" :select-options="tpmovcaixaList"
                  placeholder="Tipo movimento" label="Tipo do movimento" disabled></form-field>
              </div>
              <div class="w-100"></div>
              <div class="col-md-6 col-12">
                <form-field v-model="vmovcaixa.valor" ref="valor" type="value" :precision="2" col="12" label="Valor do movimento"
                  name="valor" :v-errors="errors" v-validate="metadata.vmovcaixa.valor.validator"></form-field>
              </div>
              <!-- <div class="col-md-12 col-12"> -->
              <!-- <input-checkbox v-model="imprimirComprovante" :value-checked="true" :value-unchecked="false" label="Imprimir Comprovante"></input-checkbox> -->
              <!-- </div> -->
              <div class="col-md-12 col-12">
                <form-field v-model="vmovcaixa.obs" type="text" col="12" :metadata="metadata.vabertura.obs" name="obs"
                  :v-errors="errors" v-validate="metadata.vmovcaixa.obs.validator"></form-field>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col">
                <v-button label="Confirmar" :nb-btdef="true" @click="handleFinaliza"></v-button>
                <v-button label="Cancelar" @click="handleRetorna"></v-button>
              </div>
            </div>

            <div class="w-100" v-for="(item, index) in vmovcaixaList" :key="index">
              <div class="row border m-2 p-1">
                <div class="col-md-3 col-4">
                  <span class="lbl-list"> Data </span>
                  <span class="data-list"> {{ item.data | formatDataHora }}</span>
                </div>
                <div class="col-md-3 col-4">
                  <span class="lbl-list"> Operador </span>
                  <span class="data-list"> {{ item.operador }}</span>
                </div>
                <div class="col-md-3 col-4">
                  <span class="lbl-list"> Valor </span>
                  <span class="data-list"> {{ item.valor | formatValue(2) }}</span>
                </div>
                <div class="col-auto text-right">
                  <v-button class="float-right" icon="fa-trash" title="" @click="handleConfirmaDelete(index)"></v-button>
                  <!-- <v-button class="float-right" icon="fa-print" title="" @click="handleImprimir(index)"></v-button> -->
                </div>
                <div class="col-md-12 col-12" v-if="item.obs">
                  <span class="lbl-list"> Observação </span>
                  <span class="data-list"> {{ item.obs }}</span>
                </div>
                <div class="col-auto p-2" v-if="item.confirmaexclusao">
                  <v-button label="Confirmar Exclusão" :danger="true" @click="handleDelete(item)"></v-button>
                  <v-button label="Cancelar" @click="item.confirmaexclusao = false"></v-button>
                </div>
              </div>
            </div>


          </div>
        </div>




      </div>
    </Trap>
  </div>
</template>

<script>
import Trap from "vue-focus-lock";
import { formatValue } from '../shared/utils'
import { apiORDS, apiORDSdelete } from '../shared/api-functions'

export default {
  name: 'varejo-vmcaixa-form',

  props: {
    params: {},
  },

  data() {
    return {
      lCrud: 'ins',

      vmovcaixa: {
        tpmovcaixa: null,
        valor: 0,
        obs: null,
      },

      vmovcaixaList: [],

      // imprimirComprovante: true,
    }
  },

  computed: {

    metadata: function () {
      return this.$store.getters.getEntities.metadata
    },

    tpmovcaixaList: function () {
      //lista de usuarios para selecao
      let options = [];
      options.push({ id: "E", text: "Reforço" });
      options.push({ id: "S", text: "Sangria" });
      options.push({ id: "A", text: "Abertura" });
      return options;
    },


  },

  watch: {

  },

  filters: {

  },

  methods: {

    handleRetorna() {
      //BOTAO RETORNAR PARA VENDA
      this.$emit('resultadovmovcaixa', null, 'RETORNA')
    },

    handleFinaliza() {
      //retorna os dados do pagamento para o objeto pai
      //emite o evento "finaliza"
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.$emit('resultadovmovcaixa', this.vmovcaixa, 'OK')
        }
      })
    },

    handleImprimir(index) {
      this.codvmovcaixa = this.vmovcaixaList[index].codvmovcaixa
    },

    handleConfirmaDelete(index) {
      this.$set(this.vmovcaixaList[index], 'confirmaexclusao', true)
    },

    handleDelete(vmovcaixa) {
      this.vmovcaixa.confirmaexclusao = false

      let self = this

      apiORDSdelete(this.$store, 'varejo/vmovcaixa/' + vmovcaixa.codvmovcaixa).then(result => {
        self.loadData()
        self.$erpToastSuccess('O movimento foi excluído')
      })
    },

    async loadData() {
      let modulo = ''
      if (this.params.tpmovcaixa == 'S')
        modulo = 'varejo/vmovcaixa/list/sangria/'
      else
        modulo = 'varejo/vmovcaixa/list/reforco/'

      modulo = modulo + this.params.codvabertura

      const data = await apiORDS(this.$store.getters.urlOrds + modulo, null)
      if (data.items)
        this.vmovcaixaList = data.items
      else
        this.vmovcaixaList = []
    },

  },

  components: {
    Trap,
  },

  created() {


  },

  mounted() {

    this.vmovcaixa.tpmovcaixa = this.params.tpmovcaixa;
    this.vmovcaixa.valor = this.params.valor;
    this.vmovcaixa.obs = this.params.obs;
    this.loadData()

    this.$nextTick(function () {
      //const rect = this.$refs.pesquisa.getBoundingClientRect();
      jQuery('[data-toggle="tooltip"]').tooltip()
      this.$refs.valor.focus()
    })



  }

}

</script>








// WEBPACK FOOTER //
// src/forms-varejo/varejo-vmcaixa-form.vue